// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    VIDEO_PAGE_LOADING() {
      return {
        isLoading: true,
        videoPage: action.videoPage
      };
    },
    VIDEO_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const videoPageData = get(currentState, 'jwVideo');
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        videoPageData,
        'videoPage'
      );

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.videoPage,
        ads: adModelData
      };
    },
    VIDEO_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.videoPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
